/** @format */

export const removeSpaces = <T extends { [key: string]: any }>(data: T): T => {
  const newObj: { [key: string]: any } = {};
  for (const key in data) {
    const value = data[key];
    newObj[key] = typeof value === "string" ? value.replace(/^ +/, "") : value;
  }
  return newObj as T;
};
